<div *ngIf="isVisible" class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">

        <form [formGroup]="form" (submit)="storeService()" (keydown.enter)="storeService()" method="POST">

          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:opacity-90 focus:outline-none">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="sm:flex sm:items-start px-4 py-4 lg:px-6 lg:py-6">

            <div class="mt-3 sm:mt-0 w-full">
              <h3 class="text-lg text-center font-semibold leading-6 text-gray-900" id="modal-title">Get support from expert</h3>
              <div class="mt-3">

                <p class="text-sm text-gray-500 mb-6">
                  For any of the following: Installation assistance, user training, guidance to refine your target ICP for specific user, help to design a custom SalesOMMO box and General Support.
                </p>

                <div class="sm:col-span-4">

                  <fieldset [disabled]="loading$ | async" class="mb-6">
                    <label for="service_id" class="block text-sm font-medium leading-6 text-gray-900">Services</label>
                    <div class="mt-2">
                      <select
                        id="service_id"
                        name="service_id"
                        formControlName="service_id"
                        class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-royal sm:text-sm/6"
                      >
                        <option value="" disabled selected>Select service</option>
                        <option *ngFor="let service of services" [value]="service.id">
                          {{ service.name }}
                        </option>
                      </select>
                    </div>

                    <div class="pt-1" *ngIf="form.get('service_id').touched && form.get('service_id').invalid">
                      <div class="ng-invalid text-xs text-red-500" *ngIf="form.get('service_id').errors?.['required']">
                        Service is required.
                      </div>
                    </div>
                  </fieldset>

                  <fieldset [disabled]="loading$ | async">
                    <label for="message" class="block text-sm font-medium leading-6 text-gray-900">Message</label>
                    <div class="mt-2">
                      <textarea
                        rows="2"
                        name="message"
                        id="message"
                        formControlName="message"
                        placeholder="Describe request assistance."
                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-royal sm:text-sm/6"
                      ></textarea>
                    </div>
                    <div class="pt-1" *ngIf="form.get('message')?.touched && form.get('message')?.invalid">
                      <div class="ng-invalid text-xs text-red-500" *ngIf="form.get('message')?.errors?.['required']">
                        Message is required.
                      </div>
                    </div>
                  </fieldset>


                </div>

              </div>
            </div>
          </div>

          <div class="px-4 sm:px-6 mb-6 grid grid-cols-2 gap-6">
            <button type="button" [disabled]="loading$ | async" (click)="closeModal()" class="btn btn-cancel sm:w-auto">Cancel</button>
            <button type="submit" [disabled]="loading$ | async" class="btn btn-blue sm:w-auto">Request Assistance</button>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>
